var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00042 8.17781L11.7146 12.892C11.8718 13.0438 12.0823 13.1278 12.3008 13.1259C12.5193 13.124 12.7283 13.0363 12.8828 12.8818C13.0373 12.7273 13.1249 12.5183 13.1268 12.2998C13.1287 12.0813 13.0447 11.8708 12.8929 11.7136L8.17876 6.99947L12.8929 2.28531C13.0447 2.12814 13.1287 1.91764 13.1268 1.69914C13.1249 1.48064 13.0373 1.27163 12.8828 1.11712C12.7283 0.962618 12.5193 0.874977 12.3008 0.873078C12.0823 0.87118 11.8718 0.955175 11.7146 1.10697L7.00042 5.82114L2.28626 1.10697C2.12838 0.958927 1.9191 0.878111 1.7027 0.881625C1.4863 0.885139 1.27975 0.972708 1.12676 1.1258C0.973778 1.2789 0.886355 1.4855 0.882995 1.70191C0.879634 1.91831 0.960598 2.12754 1.10876 2.28531L5.82209 6.99947L1.10792 11.7136C1.02833 11.7905 0.964846 11.8825 0.921171 11.9841C0.877497 12.0858 0.854509 12.1952 0.853547 12.3058C0.852586 12.4165 0.87367 12.5262 0.915571 12.6286C0.957472 12.731 1.01935 12.8241 1.09759 12.9023C1.17584 12.9805 1.26888 13.0424 1.37129 13.0843C1.47371 13.1262 1.58344 13.1473 1.69409 13.1463C1.80474 13.1454 1.91409 13.1224 2.01576 13.0787C2.11743 13.0351 2.20938 12.9716 2.28626 12.892L7.00042 8.17781Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlackIcon);
export default __webpack_public_path__ + "static/media/close_black_icon.eb2b627af09201ff2046644ab0599295.svg";
export { ForwardRef as ReactComponent };